// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SchematisationReferenceLocation
 */
export interface SchematisationReferenceLocation {
  /**
   *
   */
  id: string;
}

/**
 * Check if a given object implements the SchematisationReferenceLocation interface.
 */
export function instanceOfSchematisationReferenceLocation(
  value: object
): value is SchematisationReferenceLocation {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function SchematisationReferenceLocationFromJSON(
  json: any
): SchematisationReferenceLocation {
  return SchematisationReferenceLocationFromJSONTyped(json, false);
}

export function SchematisationReferenceLocationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SchematisationReferenceLocation {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
  };
}

export function SchematisationReferenceLocationToJSON(json: any): SchematisationReferenceLocation {
  return SchematisationReferenceLocationToJSONTyped(json, false);
}

export function SchematisationReferenceLocationToJSONTyped(
  value?: SchematisationReferenceLocation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
  };
}
